/* eslint-disable @typescript-eslint/no-unused-vars */
import { memo } from 'react';
import Stepper from '@mui/material/Stepper';
import { informationSteps } from 'libs/mindUtils';
import { Step, StepButton } from '@mui/material';
import useProjectInfoProvider from 'hooks/useProjectInfoProvider';

function HeaderStep({ projectType }: { projectType: string }): JSX.Element {
  const { inputs, dcInputs, onChange, onChangeDC, dispatch: dispatchProjectInfo } = useProjectInfoProvider();
  const { activeStep, completed } = inputs;
  const { activeStep: activeStepDC, completed: completedDC } = dcInputs;

  const handleStep = (step: number) => () => {
    if (projectType === 'ID') {
      onChange('activeStep', step);
    } else if (projectType === 'DC') {
      onChangeDC('activeStep', step);
    }
  };

  return (
    <Stepper nonLinear activeStep={projectType === 'ID' ? activeStep : activeStepDC} alternativeLabel>
      {informationSteps.map((label, index) => (
        <Step key={label} completed={projectType === 'ID' ? completed[index] : completedDC[index]}>
          <StepButton color="inherit" onClick={handleStep(index)} sx={{ p: '24px 0px', m: '-24px 0px' }}>
            {projectType === 'DC' && index === 1 ? '그리드 설정' : label}
          </StepButton>
        </Step>
      ))}
    </Stepper>
  );
}

export default memo(HeaderStep);
